import React from 'react';
import './styles.scss';
import { Flex, Skeleton } from '@mantine/core';

const LoaderContentItem = () => {
  return (
    <div className="container_content_item">
      <Flex direction={'column'} h={'100%'} justify={'space-between'}>
        <Flex direction={'column'} gap={12}>
          <Skeleton height={110} />

          <Flex direction={'column'} gap={5}>
            <Skeleton height={16} />
            <Skeleton height={16} width={100} />
          </Flex>
        </Flex>
        <Skeleton height={10} />
      </Flex>
    </div>
  );
};

export default LoaderContentItem;
